
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec32d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec32d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $e743031d8be1ab84$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["jAywl","index.5f32de86.js","khG8h","404.9066330b.html","lLjza","customer-contracts.c7c17a00.html","btdFm","customers.9a9a469e.html","5FFlk","home.89824f63.html","bCh2Q","payment-calculator.2c728a6a.html","9GVLg","customer.cefb20c0.html","3Kiwi","merchant.5f2716b8.html","96Jse","login.c6eabe34.html"]'));

var $45a7c2cc975ea61f$exports = {};
$45a7c2cc975ea61f$exports = new URL("404.9066330b.html", import.meta.url).toString();


var $f6dda1472a202159$exports = {};
$f6dda1472a202159$exports = new URL("customer-contracts.c7c17a00.html", import.meta.url).toString();


var $272a36189fb4a960$exports = {};
$272a36189fb4a960$exports = new URL("customers.9a9a469e.html", import.meta.url).toString();


var $966140bc98d21e6a$exports = {};
$966140bc98d21e6a$exports = new URL("home.89824f63.html", import.meta.url).toString();


var $33a1c08df96ab661$exports = {};
$33a1c08df96ab661$exports = new URL("payment-calculator.2c728a6a.html", import.meta.url).toString();


var $3d92d979c8665b77$exports = {};
$3d92d979c8665b77$exports = new URL("customer.cefb20c0.html", import.meta.url).toString();


var $05689d22081db540$exports = {};
$05689d22081db540$exports = new URL("merchant.5f2716b8.html", import.meta.url).toString();


var $747bef99937a9e0f$exports = {};
$747bef99937a9e0f$exports = new URL("login.c6eabe34.html", import.meta.url).toString();


const $388b617130f03bd4$var$route = (event)=>{
    event = event || window.event;
    event.preventDefault();
    window.history.pushState({}, "", event.currentTarget.href);
    $388b617130f03bd4$var$handleLocation();
};
const $388b617130f03bd4$var$routes = {
    404: (0, (/*@__PURE__*/$parcel$interopDefault($45a7c2cc975ea61f$exports))),
    "/": (0, (/*@__PURE__*/$parcel$interopDefault($966140bc98d21e6a$exports))),
    "/payment-calculator": (0, (/*@__PURE__*/$parcel$interopDefault($33a1c08df96ab661$exports))),
    "/customers": (0, (/*@__PURE__*/$parcel$interopDefault($272a36189fb4a960$exports))),
    "/customer-contract": (0, (/*@__PURE__*/$parcel$interopDefault($f6dda1472a202159$exports))),
    "/login": (0, (/*@__PURE__*/$parcel$interopDefault($747bef99937a9e0f$exports))),
    "/login/customer": (0, (/*@__PURE__*/$parcel$interopDefault($3d92d979c8665b77$exports))),
    "/login/merchant": (0, (/*@__PURE__*/$parcel$interopDefault($05689d22081db540$exports)))
};
const $388b617130f03bd4$var$settingEnvBanner = ()=>{
    const currentENV = "PROD";
    if (currentENV === "PROD") return;
    const ribbonColor = {
        STG: "seconday",
        QA: "warning",
        DEV: "primary"
    };
    const envSpan = document.createElement("span");
    const envText = document.createTextNode(currentENV);
    const envDiv = document.getElementById("env-ribbon");
    envSpan.appendChild(envText);
    envDiv.append(envSpan);
    envDiv.classList.add(`ribbon-${ribbonColor[currentENV]}`);
};
$388b617130f03bd4$var$settingEnvBanner();
const $388b617130f03bd4$var$setFormAction = ()=>{
    const currentPortal = "secure.allegrocredit.com";
    const merchantForm = document.getElementById("merchant-portal");
    const customerForm = document.getElementById("customer-portal");
    if (merchantForm) merchantForm.action = `https://${currentPortal}/merchant-login/`;
    if (customerForm) customerForm.action = `https://${currentPortal}/customer-portal/`;
};
const $388b617130f03bd4$var$handleLocation = async ()=>{
    const { hostname: hostname, pathname: pathname } = window.location;
    const BASE_URL = "https://www.allegrocredit.com";
    const isBetaOrTest = /beta|test/.test(hostname);
    const isCouponOrApply = /coupon|apply/.test(pathname);
    if (isCouponOrApply) {
        const BASEURL = isBetaOrTest ? hostname : BASE_URL;
        const redirect = `${BASEURL}${pathname}`;
        window.location.replace(redirect);
    } else {
        const absolutePath = pathname.length === 1 ? pathname : pathname.replace(/\/+$/, "");
        const template = $388b617130f03bd4$var$routes[absolutePath] || $388b617130f03bd4$var$routes[404];
        const html = await fetch(template).then((data)=>data.text());
        document.getElementById("main-page").innerHTML = html;
        window.scrollTo({
            top: 0
        });
        $388b617130f03bd4$var$setFormAction();
    }
};
window.onpopstate = $388b617130f03bd4$var$handleLocation;
window.route = $388b617130f03bd4$var$route;
$388b617130f03bd4$var$handleLocation();
function $388b617130f03bd4$var$round(x) {
    return Math.round(x * 100) / 100;
}
function $388b617130f03bd4$var$calculatePayment(principal, interest, payments) {
    var returnValue = "";
    var x = 0;
    var af = 0;
    var raf = 0;
    var monthly = 0;
    var interest_free_months = 0;
    if (arguments.length >= 4) interest_free_months = arguments[3];
    if (interest > 0) {
        x = Math.pow(1 + interest, payments);
        af = x * interest / (x - 1);
        raf = af / (1 + interest_free_months * af);
        monthly = principal * raf;
    } else monthly = principal / payments;
    if (!isNaN(monthly) && monthly != Number.POSITIVE_INFINITY && monthly != Number.NEGATIVE_INFINITY) returnValue = $388b617130f03bd4$var$round(monthly);
    return returnValue;
}
const $388b617130f03bd4$var$calculate = ()=>{
    var doValidation = true;
    var doCalculation = true;
    var $type = $("#payment-calculator-modal-type");
    var type = $type.val();
    if (type === undefined) type = "";
    else type = "-" + type;
    var plus_rent = $("#is_rental_y").parent().parent().data("steinway") && $("#is_rental_y").prop("checked");
    var principal = $("#payment-calculator-modal-amount-financed").val();
    if (principal) {
        if (principal !== "") principal = numeral().unformat(principal);
        else principal = 0;
        if (doValidation) {
            if (principal == 0) {
                doCalculation = false;
                $("#payment-calculator-modal-amount-financed").parents(".form-group").addClass("has-error");
            } else $("#payment-calculator-modal-amount-financed").parents(".form-group").removeClass("has-error");
        }
    } else if (doValidation) {
        doCalculation = false;
        $("#payment-calculator-modal-amount-financed").parents(".form-group").addClass("has-error");
    }
    var $interest = $("#payment-calculator-modal-apr");
    var interest = $interest.val();
    if (typeof $interest !== "undefined") {
        if (typeof interest !== "undefined" && interest !== "") interest = numeral().unformat(interest);
        else interest = 0;
        interest = interest / 100 / 12;
    }
    var doInterest = false;
    if ($interest.length === 0 || typeof interest === "undefined") doInterest = true;
    else if (interest) {
        if (doValidation) {
            if (interest > 0) $("#payment-calculator-modal-apr").parents(".form-group").removeClass("has-error");
            else {
                doCalculation = false;
                $("#payment-calculator-modal-apr").parents(".form-group").addClass("has-error");
            }
        }
    } else if (doValidation) {
        doCalculation = false;
        $("#payment-calculator-modal-apr").parents(".form-group").addClass("has-error");
    }
    var month_rows = $("#payment-calculator-modal-months" + type).children("tr");
    for(var i = 0; i < month_rows.length; i++){
        var month_row = $(month_rows[i]);
        var months = month_row.data("months");
        var extra_months = 0;
        if (plus_rent) extra_months = 6;
        var min_amount = parseInt(month_row.data("min"), 10);
        if (isNaN(min_amount)) min_amount = 0;
        var max_amount = parseInt(month_row.data("max"), 10);
        if (isNaN(max_amount)) max_amount = 0;
        if (doInterest) interest = parseFloat(month_row.data("apr")) / 100 / 12;
        var payment = $("#payment-calculator-modal-months" + type + "-" + months);
        if (min_amount !== 0 && min_amount > principal || max_amount !== 0 && max_amount < principal) payment.html("N/A");
        else payment.html("$" + numeral($388b617130f03bd4$var$calculatePayment(principal, interest, months)).format("0,0.00"));
    }
};
window.calculate = $388b617130f03bd4$var$calculate;
const $388b617130f03bd4$var$settingCookieAndGA = ()=>{
    function gtag() {
        dataLayer.push(arguments);
    }
    const currentENV = "PROD";
    if (currentENV === "PROD" || currentENV === "TEST") {
        const GOOGLE_ANALYTICS_ID = "G-CK3W2YDXYP", COOKIE_ID = "602bc6d2-cf4c-44a9-9bdc-bfcd7d7efd93";
        const analyticScript = document.createElement("script");
        analyticScript.src = "https://www.googletagmanager.com/gtag/js";
        analyticScript.async = true;
        document.body.appendChild(analyticScript);
        window.dataLayer = window.dataLayer || [];
        gtag("js", new Date());
        gtag("config", GOOGLE_ANALYTICS_ID);
        const cookieScript = document.createElement("script");
        cookieScript.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
        cookieScript.type = "text/javascript";
        cookieScript.setAttribute("data-domain-script", COOKIE_ID);
        document.body.appendChild(cookieScript);
    }
};
$388b617130f03bd4$var$settingCookieAndGA();


//# sourceMappingURL=index.5f32de86.js.map
